import { render } from "./TextBlockWithImageGridPreview.vue?vue&type=template&id=0226594b&scoped=true"
import script from "./TextBlockWithImageGridPreview.vue?vue&type=script&lang=js"
export * from "./TextBlockWithImageGridPreview.vue?vue&type=script&lang=js"

import "./TextBlockWithImageGridPreview.vue?vue&type=style&index=0&id=0226594b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0226594b"]])

export default __exports__